/**
 * Build a display-ready conversation after create/find when the API omits
 * other_participant (shows as the raw type label "direct" until refresh).
 */
export function enrichConversationDisplay(conversation, options = {}) {
  if (!conversation || typeof conversation !== 'object') return conversation;

  const {
    selectedParticipantIds = [],
    availableUsers = [],
    currentUserId = null,
  } = options;

  if (conversation.conversation_type !== 'direct') {
    return conversation;
  }

  if (conversation.other_participant?.username) {
    return conversation;
  }

  const me = currentUserId == null ? null : Number(currentUserId);
  const participants = Array.isArray(conversation.participants)
    ? conversation.participants
    : [];

  const fromParticipants = participants
    .map((p) => {
      if (!p) return null;
      if (p.username || p.user) {
        return {
          id: p.id ?? p.user?.id,
          username: p.username || p.user?.username,
          profile: p.profile || p.user?.profile,
          photo_url: p.photo_url || p.user?.photo_url,
        };
      }
      return null;
    })
    .find((p) => p && (me == null || Number(p.id) !== me));

  if (fromParticipants?.username) {
    return { ...conversation, other_participant: fromParticipants };
  }

  const peerId = selectedParticipantIds
    .map((id) => Number(id))
    .find((id) => Number.isFinite(id) && (me == null || id !== me));

  if (peerId != null) {
    const buddy = availableUsers.find((u) => Number(u.id) === peerId);
    if (buddy?.username) {
      return {
        ...conversation,
        other_participant: {
          id: buddy.id,
          username: buddy.username,
          profile: buddy.profile,
          photo_url: buddy.photo_url,
        },
      };
    }
  }

  return conversation;
}
